{
  "w": 32,
  "h": 48,
  "rows": [
    "..........GGGGGG................",
    "........GGGGWWWWWW..............",
    "......GGWWWWWWWWGGG..GG.........",
    ".....WWWWWWWGGGGGGGGWWWWW.......",
    ".....WWWGGGGGGGGWWWWWWWWGGG.....",
    "....GGGGGGGGWWWWWWWWGGGGGGGG....",
    "....GGGGWWWWWWWWGGGGGGGGWWWW....",
    "....WWWWWWWgGGGGGGGGWWWWWWWWG...",
    "..WWWWWWGGGGGGGGWWWWWWWWGGGGG...",
    ".WWWGGGGGGGGWWWWWWWWGGGGGGG..W..",
    ".GGGGGGGWWWWWWWWGGGGgGgGWWWWWW..",
    "GGGGWWWWWWWWGGGGGGGGWWgWWWWWGG..",
    "W..WWWWWGGGGGGGGWWWWWgWWGGGGGG..",
    "WWWWGgGgggggWWWWWWWWGgGGGGGGWW..",
    "GGGGGggggggggWWWGGGGgggggWWWWW..",
    "GGGGggggggggggGGGGgggggggggWGGG.",
    "WWWWgggggggggggGWgggggggggggGGG.",
    "GGGggggggggggggGGggggggggggggGG.",
    "GGGgggggggggggggggggggggggggg...",
    "GGGGgggggggggggggggggggggggggGG.",
    ".GG..ggggggggggggggggggggggggGG.",
    "..GGGgggggggggggggggggggggggGGG.",
    "...GGGGGggggggggggggggggggggGGG.",
    "....GGGGGgggggggggggggggggGGGG..",
    ".....GGGGGGgggggggggGGGGGGGGGG..",
    "......GGGGGGGGGKGgGGGGGGGGGGG...",
    ".......GGGGGGGGGgGGGGGGGGGG.....",
    "..........GGGGGGGGGG............",
    ".............RRRRRR.............",
    ".............RRKRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRKRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRKRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRKRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRRRRR.............",
    ".............RRKRRR.............",
    ".............RRRRRR.............",
    "..........WWWWWWWWWWWWW........."
  ],
  "legend": {
    "K": "C.BLACK",
    "G": "C.B_GREEN",
    "g": "C.GREEN",
    "R": "C.RED",
    "W": "C.B_WHITE"
  }
}
